module.exports = __webpack_public_path__ + "img/empty-address-bg.7b6758c3.png";